import { Config } from 'modules/config/state/config-types'
import {
  OrderDonorCoveredFeesSlice,
  OrderDonorCoveredFeesValue,
} from './order-donor-covered-fees-types'

export const DEFAULT_DCF_VALUE: OrderDonorCoveredFeesValue = {
  isLoading: true,
  isChecked: false,
  fee: 0,
  totalAmount: 0,
  applied_application_fee_percent: null,
  applied_processor_fee_percent: null,
  applied_raw_processor_fee_flat: null,
  applied_flex_rate_percent: null,
  raw_application_fee_amount: null,
  raw_processor_fee_amount: null,
  raw_flex_rate_amount: null,
  raw_initial_gross_amount: null,
}

export const makeOrderDonorCoveredFeesInitialState = (
  config: Config,
): OrderDonorCoveredFeesSlice => {
  let value: OrderDonorCoveredFeesValue | undefined

  if (!value) {
    value = DEFAULT_DCF_VALUE
  }

  return {
    value: {
      ...DEFAULT_DCF_VALUE,
      isChecked: config.dcf.checkedByDefault,
    },
  }
}
